import {ClarityInjector} from '@src/utility/logger/libs/clarity'
import {PosthogInjector} from '@src/utility/logger/libs/posthog'

import {LoggerStrategy} from './strategy'

const isDeploy = ['stage', 'sandbox', 'production'].includes(import.meta.env.VITE_ENVIRONMENT ?? 'development')

export const logger = new LoggerStrategy([
  {
    class: new PosthogInjector(),
    enabled: isDeploy
  },
  {
    class: new ClarityInjector(),
    enabled: isDeploy
  }
])
